import { useLocale } from '../i18n/LocaleProvider'
import { useState } from 'react'
import { useInquiry } from './InquirySheet'
import { SiteButton } from './SiteButton'
import './CTAStrip.css'

export default function CTAStrip({ bg = '#ffffff' }: { bg?: string }) {
  const { t } = useLocale()
  const { openInquiry } = useInquiry()
  const [email, setEmail] = useState('')
  const [consent, setConsent] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!consent) return
    openInquiry({ email })
  }

  return (
    <section className="cta-strip" style={{ background: bg }}>
      <div className="container">
        <div className="cta-strip-inner">
          <div className="cta-strip-text">
            <h2 className="cta-strip-h2">{t("Ready to enter Japan?")}</h2>
            <p className="cta-strip-p"> {t("We're conducting discovery calls with our first pilot clients. If you're a SaaS or AI company eyeing Japan, let's talk.")} </p>
          </div>
          <form className="cta-strip-form" onSubmit={handleSubmit}>
            <div className="cta-strip-form-row">
              <input
                type="email"
                className="cta-strip-email"
                placeholder={t("Email address")}
                aria-label={t("Email address")}
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <SiteButton type="submit" size="compact"> {t("Get in touch")} </SiteButton>
            </div>
            <label className="cta-strip-consent">
              <input
                type="checkbox"
                checked={consent}
                onChange={e => setConsent(e.target.checked)}
              /> {t("I agree to receive communications from Bybeit.")} </label>
          </form>
        </div>
      </div>
    </section>
  )
}
